import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { TextField, Toggle } from 'redux-form-material-ui';
import { IconButton, FlatButton, Subheader } from 'material-ui';
import { deepPurple400 } from 'material-ui/styles/colors';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import AddIcon from 'material-ui/svg-icons/content/add';
import RemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { presence } from 'dash-front/helpers/validation';
import { createSocialCampaign } from 'dash-front/actions/social-campaigns';

const initialValues = {
    customUrl: '${url}',
    keys: [{ key: 'utm_source', value: '' }, { key: 'utm_medium', value: '' }, { key: 'utm_campaign', value: '' }]
};

const keyValRowStyle = {
    display: 'flex',
    alignItems: 'flex-end'
};
const macros = '${url}';
export const CreateSocialCampaign = connect()(
    class extends React.Component {
        save = ({ hasCustomUrl, ...rest }) => {
            console.log(rest);
            const next = !hasCustomUrl ? { ...rest, customUrl: null } : rest;
            return this.props.dispatch(createSocialCampaign(next)).then(res => {
                const { body } = res;
                if (this.props.onCreate) {
                    this.props.onCreate(body._id);
                }
            });
        };
        render() {
            return (
                <Form
                    onSubmit={this.save}
                    mutators={arrayMutators}
                    initialValues={initialValues}
                    render={({ handleSubmit, invalid, values }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Field
                                    name="name"
                                    floatingLabelText={'Campaign name'}
                                    validate={presence}
                                    component={TextField}
                                />
                                <FieldArray name="keys">
                                    {({ fields }) => (
                                        <div>
                                            <div>
                                                {fields.map((name, index) => (
                                                    <div key={name} style={keyValRowStyle}>
                                                        <Field
                                                            name={`${name}.key`}
                                                            component={TextField}
                                                            validate={presence}
                                                            floatingLabelText={'Key'}
                                                        />
                                                        <Field
                                                            name={`${name}.value`}
                                                            component={TextField}
                                                            validate={presence}
                                                            floatingLabelText={'Value'}
                                                        />
                                                        <IconButton onClick={() => fields.remove(index)}>
                                                            <RemoveIcon />
                                                        </IconButton>
                                                    </div>
                                                ))}
                                            </div>
                                            <IconButton onClick={() => fields.push({ key: '', value: '' })}>
                                                <AddIcon />
                                            </IconButton>
                                        </div>
                                    )}
                                </FieldArray>
                                <Field
                                    name={'hasCustomUrl'}
                                    type={'checkbox'}
                                    label={'Has custom tracking service'}
                                    style={{ marginTop: 12, marginBottom: 12 }}
                                    labelPosition={'right'}
                                    component={Toggle}
                                />
                                {values.hasCustomUrl ? (
                                    <div>
                                        <Subheader>
                                            Insert the target link and use macros{' '}
                                            <span style={{ color: deepPurple400 }}>{macros}</span> which will be
                                            replaced with url to place a bet
                                        </Subheader>
                                        <div style={{ paddingLeft: 16 }}>
                                            <div className="row">
                                                <Field
                                                    name={'customUrl'}
                                                    multiLine
                                                    floatingLabelText={'Custom url'}
                                                    validate={presence}
                                                    component={TextField}
                                                    className={'col-md-6'}
                                                />
                                                <div className={'col-md-6'} style={{ fontSize: 12 }}>
                                                    <i>
                                                        Example:
                                                        https://ad.doubleclick.net/ddm/clk/417890461;219470871;o?{
                                                            macros
                                                        }
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                <FlatButton disabled={invalid} label={'Save'} type={'submit'} />
                            </form>
                        );
                    }}
                />
            );
        }
    }
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/SocialCampaign.js
 **/